import * as React from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
function SvgIconCustomTrophy({
  title,
  titleId,
  ...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M13.979 14.977h-2.091V12.53c.223-.148.432-.315.626-.5.635 0 5.139-.55 5.249-7.33a.677.677 0 00-.195-.475.66.66 0 00-.465-.194H15.41c0-.483 0-.982.05-1.516a.677.677 0 00-.194-.474.643.643 0 00-.5-.194h-9.77a.669.669 0 00-.652.669c.001.533.001 1.032.052 1.515H2.703a.643.643 0 00-.466.194.686.686 0 00-.237.483c.11 6.772 4.614 7.297 5.24 7.297.196.183.405.35.627.5v2.446H5.784a1.99 1.99 0 00-1.99 1.99v.635c0 .327.266.592.593.592h11.006a.593.593 0 00.592-.592v-.635a1.99 1.99 0 00-2.006-1.964zm1.32-10.1h1.609c-.127 4.402-2.227 5.731-3.505 6.13a12.698 12.698 0 001.896-6.13zm-12.452 0h1.608c.1 2.173.756 4.283 1.905 6.13-1.279-.399-3.378-1.728-3.513-6.13zm2.336-2.184h9.397c-.11 8.009-3.327 9.414-4.31 9.66-.255.06-.522.06-.778 0-.99-.246-4.199-1.651-4.309-9.66zm3.53 10.294c.188.075.38.138.576.187.194.047.393.07.592.067.197.003.394-.02.585-.067.195-.05.388-.112.575-.187v1.99H8.713v-1.99zm6.409 4.36H4.642v-.38c0-.632.51-1.144 1.142-1.144h8.195c.63.005 1.138.514 1.143 1.143v.381z"
        fill="currentColor"
        fillRule="nonzero"
      />
    </svg>
  );
}
export default SvgIconCustomTrophy;
